import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef, Provider, Type } from '@angular/core';

export abstract class ControlValueAccessorModel<T> implements ControlValueAccessor {
    value: T;

    onModelChange: (value: T) => void = () => {};
    onModelTouched: () => void = () => {};

    writeValue(value: T): void {
        this.value = value;
    }

    registerOnChange(fn: (value: T) => void): void {
        this.onModelChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onModelTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {

    }
}

export function getProvider(type: Type<any>): Provider {
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => type),
        multi: true
    };
}

export function getValidatorProvider(type: Type<any>): Provider {
    return {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => type),
        multi: true
    };
}
